import ko from 'knockout'
import { Disposable } from '../../../../AppUtils/Framework/Disposable/Disposable'
import type { IObservableFinisher } from '../../../Model/Observables/IObservableFinisher'
import type ObservableRace from '../../../Model/Observables/ObservableRace'

export class ResultsColumnHeaderViewModel extends Disposable {
  constructor(params: {
    race: ObservableRace
    raceFinishers: ko.ObservableArray<IObservableFinisher>
  }) {
    super()

    this.race = params.race

    this.shouldShowSp = ko.pureComputed(
      () => !!params.raceFinishers?.().some(finisher => finisher.spWinPrice() > 0)
    )
  }

  public race: ObservableRace
  public shouldShowSp: ko.PureComputed<boolean>
}
